/* Customer-facing text only. Cart payloads, quote records and form values keep their existing format. */
(() => {
  'use strict';
  if (window.MaxnewI18n) return;
  let cachedText;
  let cachedData = {};
  function data() {
    const text = document.getElementById('MaxnewI18nData')?.textContent || '';
    if (text !== cachedText) {
      cachedText = text;
      try {
        const parsed = JSON.parse(text);
        cachedData = parsed && typeof parsed === 'object' ? parsed : {};
      } catch (_) {
        cachedData = {};
      }
    }
    return cachedData;
  }
  function t(id, fallback, params = {}) {
    const strings = data().strings;
    const candidate = strings && Object.hasOwn(strings, id) ? strings[id] : undefined;
    const template = typeof candidate === 'string' && candidate ? candidate : String(fallback ?? '');
    return template.replace(/{{\s*([a-zA-Z0-9_]+)\s*}}|__([A-Z0-9_]+)__/g, (match, normal, sentinel) => {
      const key = normal || sentinel.toLowerCase();
      return Object.hasOwn(params, key) ? String(params[key]) : match;
    });
  }
  function number(value) {
    const locale = document.documentElement?.lang || data().locale || undefined;
    try { return new Intl.NumberFormat(locale).format(value); }
    catch (_) { return new Intl.NumberFormat().format(value); }
  }
  window.MaxnewI18n = Object.freeze({ t, number });
})();

